import { render, staticRenderFns } from "./recipe-cna-result.vue?vue&type=template&id=75ecbafb&scoped=true&"
import script from "./recipe-cna-result.vue?vue&type=script&lang=js&"
export * from "./recipe-cna-result.vue?vue&type=script&lang=js&"
import style0 from "./recipe-cna-result.vue?vue&type=style&index=0&id=75ecbafb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75ecbafb",
  null
  
)

export default component.exports